export var EncodeMedium;
(function (EncodeMedium) {
    /**
     * The object will be sent over the network.
     */
    EncodeMedium["Network"] = "Network";
    /**
     * The object will be stored in the database.
     */
    EncodeMedium["Database"] = "Database";
})(EncodeMedium || (EncodeMedium = {}));
//# sourceMappingURL=EncodeContext.js.map